import Vue from 'vue'
import VueRouter from 'vue-router'
import Cart from '@/views/Cart'
import Customer from '@/views/Customer'
import CustomerForm from '@/views/CustomerForm'
import Shipping from '@/views/Shipping'
import Summary from '@/views/Summary'

Vue.use(VueRouter)

const routes = [
    {
        path: '/webshop/step/cart',
        name: 'Cart',
        component: Cart
    },
    {
        path: '/webshop/step/customer',
        name: 'Customer',
        component: Customer
    },
    {
        path: '/webshop/step/customer-form',
        name: 'CustomerForm',
        component: CustomerForm
    },
    {
        path: '/webshop/step/shipping',
        name: 'Shipping',
        component: Shipping
    },
    {
        path: '/webshop/step/summary',
        name: 'Summary',
        component: Summary
    }
]

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: "active",
    base: process.env.BASE_URL,
    routes
})

export default router
